export default "__VITE_ASSET__CrZBAhZT__"